export default __webpack_public_path__ + "static/media/Priest's Visage of the Black Thread.7941b93d.jpg";